import { render, staticRenderFns } from "./cmp-left-bottom-two.vue?vue&type=template&id=0b04be2c&scoped=true"
import script from "./cmp-left-bottom-two.vue?vue&type=script&lang=js"
export * from "./cmp-left-bottom-two.vue?vue&type=script&lang=js"
import style0 from "./cmp-left-bottom-two.vue?vue&type=style&index=0&id=0b04be2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04be2c",
  null
  
)

export default component.exports